export const CART_STORAGE_KEY = 'nisr-cart-v1';

export function normalizeCart(value) {
  if (!Array.isArray(value)) return [];

  const items = new Map();
  value.forEach((item) => {
    const product = item?.product;
    const qty = Number(item?.qty);
    if (
      !product ||
      (typeof product.id !== 'string' && typeof product.id !== 'number') ||
      !Number.isFinite(Number(product.price)) ||
      !Number.isFinite(qty) ||
      qty < 1
    ) return;

    const id = String(product.id);
    const hasColor = typeof item.variant?.color === 'string';
    const hasSize = typeof item.variant?.size === 'string' && item.variant.size.trim() !== '';
    const variant = item.variant && (hasColor || hasSize)
      ? {
          ...(hasColor ? {
            color: item.variant.color,
            name: String(item.variant.name ?? item.variant.color),
            image: String(item.variant.image ?? ''),
          } : {}),
          ...(hasSize ? { size: item.variant.size.trim() } : {}),
        }
      : null;
    const key = `${id}::${variant?.color ?? ''}::${variant?.size ?? ''}`;
    const normalized = { product, qty: Math.floor(qty), ...(variant ? { variant } : {}) };
    const existing = items.get(key);
    items.set(key, existing ? { ...existing, qty: existing.qty + normalized.qty } : normalized);
  });

  return [...items.values()];
}

export function readCart(storage = window.localStorage) {
  try {
    return normalizeCart(JSON.parse(storage.getItem(CART_STORAGE_KEY) || '[]'));
  } catch {
    return [];
  }
}

export function writeCart(cart, storage = window.localStorage) {
  try {
    storage.setItem(CART_STORAGE_KEY, JSON.stringify(normalizeCart(cart)));
  } catch {
    // The cart remains usable for this session when browser storage is unavailable.
  }
}

export function getCartCount(cart) {
  return cart.reduce((count, item) => count + item.qty, 0);
}

export function getCartSubtotal(cart) {
  return cart.reduce((subtotal, item) => subtotal + Number(item.product.price) * item.qty, 0);
}
